import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const repairOrderCategoriesAdapter = getAdapter({ idFieldName: 'id' });

const repairOrderCategoriesSlice = createSlice({
  name: 'repairOrderCategories',
  initialState: repairOrderCategoriesAdapter.getInitialState(),
  reducers: {
    setRepairOrderCategories: (state, { payload: { repairOrderCategories } }) => {
      repairOrderCategoriesAdapter.setAll(state, repairOrderCategories);
    },
  },
});

const selectors = repairOrderCategoriesAdapter.getSelectors(
  ({ repairOrderCategories }) => repairOrderCategories,
);

export const getRepairOrderCategories = (state) => selectors.selectAll(state);

export const { setRepairOrderCategories } = repairOrderCategoriesSlice.actions;

export default repairOrderCategoriesSlice.reducer;
